import React, { useState } from "react";
import { BrowserRouter as Router, Routes, Route } from "react-router-dom";

import Navigation from "./components/Navigation";
import Hero from "./components/Hero";
import About from "./components/About";
import MissionVisionValues from "./components/MissionVisionValues";
import Products from "./components/Products";
import Industries from "./components/Industries";
import Quality from "./components/Quality";
import Clients from "./components/Clients";
import IndustriesClients from "./components/IndustriesClients";
import Contact from "./components/Contact";
import Footer from "./components/Footer";

import "./App.css";

function App() {
  const [activeSection, setActiveSection] = useState("home");
  const [isMobileMenuOpen, setIsMobileMenuOpen] = useState(false);
  const [searchQuery, setSearchQuery] = useState("");

  const scrollToSection = (sectionId) => {
    setActiveSection(sectionId);
    setIsMobileMenuOpen(false);
    const element = document.getElementById(sectionId);
    if (element) {
      element.scrollIntoView({ behavior: "smooth" });
    }
  };

  const handleSearch = (e) => {
    e.preventDefault();
    console.log("Searching for:", searchQuery);
    alert(`Searching for: ${searchQuery}`);
  };

  return (
    <Router>
      <div className="app">
        <Routes>
          <Route
            path="/"
            element={
              <>
                <Navigation
                  activeSection={activeSection}
                  setActiveSection={setActiveSection}
                  isMobileMenuOpen={isMobileMenuOpen}
                  setIsMobileMenuOpen={setIsMobileMenuOpen}
                  searchQuery={searchQuery}
                  setSearchQuery={setSearchQuery}
                  handleSearch={handleSearch}
                />

                <main>
                  <Hero scrollToSection={scrollToSection} />
                  <About />
                  <MissionVisionValues />
                  <Quality />
                  <Contact />
                </main>

                <Footer />
              </>
            }
          />
          <Route path="/products" element={<Products />} />
          <Route path="/industries" element={<Industries />} />
          <Route path="/clients" element={<Clients />} />
          <Route path="/industries-clients" element={<IndustriesClients />} />
        </Routes>
      </div>
    </Router>
  );
}

export default App;
